import React, { lazy } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import SuspenseLoader from '../components/loader/SuspenseLoader'
import LandingLayoutPage from '../modules/Landing/container/Landing'
const HomePage = lazy(() => import('../modules/Landing/pages/Home'))
const ServicesPage = lazy(() => import('../modules/Landing/pages/Services'))
const BookAppoinmentForm = lazy(() => import('../modules/Landing/pages/BookAppoinmentForm'))
const Appoinments = lazy(() => import('../modules/Landing/pages/Appoinments'))
const FollowUpTelevisit = lazy(() => import('../modules/Landing/pages/FollowUpTelevisit'))
const CartItem = lazy(() => import('../modules/Landing/pages/CartItem'))
const AimTeams = lazy(() => import('../modules/Landing/pages/AimTeams'))
const MicroBiomeScience = lazy(() => import('../modules/Landing/pages/MicroBiomeScience'))
const ContactUs = lazy(() => import('../modules/Landing/pages/ContactUs'))
const BlogDetails = lazy(() => import('../modules/Landing/pages/BlogDetails'))
const ThankYou = lazy(() => import("../modules/Landing/pages/ThankYou"))
const ThankYou2 = lazy(() => import("../modules/Landing/pages/ThankYou2"))
const AntiInflammatryBlog = lazy(() => import("../modules/Landing/components/BlogDetails/AntiInflammatroyBlog"))
const InflammatoryBlog = lazy(() => import("../modules/Landing/components/BlogDetails/InflammatoryBlog"))
const GutBrainBlog = lazy(() => import("../modules/Landing/components/BlogDetails/GutBrainBlog"))
const LeakyGutBlog = lazy(() => import("../modules/Landing/components/BlogDetails/LeakyGutBlog"))
const IntegrativeMedicine = lazy(() => import("../modules/Landing/components/BlogDetails/IntegrativeMedicine"))
const RootCauseBlog = lazy(() => import("../modules/Landing/components/BlogDetails/RootCauseBlog"))
const HippoCreatesBlog = lazy(() => import("../modules/Landing/components/BlogDetails/HippoCreatesBlog"))
const SiboBlog = lazy(() => import("../modules/Landing/components/BlogDetails/SiboBlog"))
const MeduicineGuide = lazy(() => import("../modules/Landing/components/BlogDetails/MedicineGuide"))
const AppoinmentPage = lazy(() => import("../modules/Landing/pages/BookAppoinment"))

function Root() {

  return (
    <BrowserRouter>
      <React.Suspense fallback={<SuspenseLoader />}>
        <LandingLayoutPage>
          <Routes>
            <Route path='/home' element={<HomePage />} />
            <Route path='/services' element={<ServicesPage />} />
            {/* <Route path='/book-appointment' element={<BookAppoinmentForm />} /> */}
            <Route path='/appoinments' element={<Appoinments />} />
            <Route path='/follow-up-televisit/:id' element={<FollowUpTelevisit />} />
            <Route path='/cart' element={<CartItem />} />
            <Route path='/teams' element={<AimTeams />} />
            <Route path='/aimm-blog' element={<MicroBiomeScience />} />
            <Route path='/contact-us' element={<ContactUs />} />
            <Route path='/blog-details/:id' element={<BlogDetails />} />
            <Route path='/thank-you' element={<ThankYou />} />
            <Route path='/thank-you2' element={<ThankYou2 />} />
            {/* <Route path='/book-appoinment' element={<AppoinmentPage />} /> */}

            <Route path='/blog/anti-inflammatory' element={<AntiInflammatryBlog />} />
            <Route path='/blog/inflammatory-bowel-disease' element={<InflammatoryBlog />} />
            <Route path='/blog/gut-brain' element={<GutBrainBlog />} />
            <Route path='/blog/leaky-gut' element={<LeakyGutBlog />} />
            <Route path='/blog/integrative-medicine' element={<IntegrativeMedicine />} />
            <Route path='/blog/root-cause' element={<RootCauseBlog />} />
            <Route path='/blog/hippocrates-blog' element={<HippoCreatesBlog />} />
            <Route path='/blog/sibo-blog' element={<SiboBlog />} />
            <Route path='/blog/medicine-guide' element={<MeduicineGuide />} />

            <Route path='*' element={<Navigate to='/home' replace />} />
          </Routes>
        </LandingLayoutPage>
      </React.Suspense>
    </BrowserRouter>
  )
}

export default Root
